import { render } from "./Confirmacion.vue?vue&type=template&id=52c26a1d&scoped=true"
import script from "./Confirmacion.vue?vue&type=script&lang=js"
export * from "./Confirmacion.vue?vue&type=script&lang=js"

import "./Confirmacion.vue?vue&type=style&index=0&id=52c26a1d&scoped=true&lang=css"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c26a1d"]])

export default __exports__